<div class="address-form-page">
    <h5
        [ngClass]="{ 'text-right': lang == 'ar' }"
        class="title-address"
        style="
            margin-bottom: 24px;
            margin-left: 10px;
            font-size: 17px;
            text-transform: capitalize;
        "
        translate
    >
        {{ "prescription.newAddress" | translate }}
    </h5>

    <div mat-dialog-content style="overflow: visible">
        <form
            [formGroup]="addAddressForm"
            [ngClass]="{ 'text-right': lang == 'ar' }"
        >
            <div [ngClass]="{ 'text-right': lang == 'ar' }" fxLayout="row wrap">
                <ng-container
                    *ngIf="
                        environmentVariables?.SHOW_ADDRESS_MAP &&
                        !environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP
                    "
                >
                    <div
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        ngClass.sm="mt-2"
                        ngClass.xs="mt-2"
                        *ngIf="lat && lng"
                        class="relative-map"
                    >
                        <agm-map
                            [latitude]="lat"
                            [longitude]="lng"
                            [zoom]="15"
                            (centerChange)="centerChanged($event)"
                        >
                            <!-- <agm-marker
                            [latitude]="lat"
                            [longitude]="lng"
                        ></agm-marker> -->
                        </agm-map>
                        <div
                            class="map-center-overlay"
                            *ngIf="
                                cordnates?.lat_marker !== 0 &&
                                cordnates.lng_marker !== 0
                            "
                            [attr.latitude]="cordnates.lat_marker"
                            [attr.longitude]="cordnates.lng_marker"
                        >
                            <img  loading="lazy" 
                                src="../../../assets/images/marker.svg"
                                   alt="marker image"
                                width="30"
                                height="30"
                            />
                        </div>
                    </div>
                    <div
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        ngClass.sm="mt-2"
                        ngClass.xs="mt-2"
                    >
                        <h6 (click)="setCurrentPosition()" class="get-location">
                            {{ "prescription.myCurrentLocation" | translate }}
                        </h6>
                    </div>
                </ng-container>
                <div
                    fxFlex="100"
                    fxFlex.gt-sm="100"
                    *ngIf="
                        environmentVariables?.SHOW_ADDRESS_MAP &&
                        environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP &&
                        environmentVariables?.ENABLE_MULTI_INVENTORY
                    "
                    class="map-area"
                >
                    <app-multi-invintory-area
                        [addressForm]="true"
                        [address_coordnates]="address"
                        (addressemit)="setAddress($event)"
                    ></app-multi-invintory-area>
                </div>
                <ng-container>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_NAME_CONFIG != 'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <mat-select
                                formControlName="name"
                                placeholder="{{
                                    environmentVariables?.ADDRESS_NAME_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_NAME_LABEL_EN
                                            : environmentVariables?.ADDRESS_NAME_LABEL_AR
                                        : ('input_text.inputAddressName'
                                          | translate)
                                }}"
                            >
                                <mat-option
                                    *ngFor="let address of addressNames"
                                    [value]="address.name"
                                >
                                    {{
                                        lang == "en"
                                            ? address.name
                                            : address.name_ar
                                    }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.name?.errors
                                        ?.required
                                "
                                translate
                            >
                                {{
                                    environmentVariables?.ADDRESS_NAME_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_NAME_LABEL_EN
                                            : environmentVariables?.ADDRESS_NAME_LABEL_AR
                                        : ("input_text.inputAddressName"
                                          | translate)
                                }}
                                {{
                                    "prescription.Required" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_STREET_CONFIG !=
                            'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="66.66"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <input
                                formControlName="address"
                                matInput
                                placeholder="{{
                                    environmentVariables?.ADDRESS_STREET_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_STREET_LABEL_EN
                                            : environmentVariables?.ADDRESS_STREET_LABEL_AR
                                        : ('prescription.addressPlaceholderFull'
                                          | translate)
                                }}
                           "
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.address?.errors
                                        ?.required
                                "
                                translate
                            >
                                {{
                                    environmentVariables?.ADDRESS_STREET_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_STREET_LABEL_EN
                                            : environmentVariables?.ADDRESS_STREET_LABEL_AR
                                        : ("prescription.addressPlaceholderFull"
                                          | translate)
                                }}
                                {{
                                    "prescription.Required" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            (!environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP &&
                                environmentVariables?.ENABLE_MULTI_INVENTORY) ||
                            !environmentVariables?.ENABLE_MULTI_INVENTORY ||
                            !environmentVariables?.SHOW_ADDRESS_MAP
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <mat-select
                                (selectionChange)="
                                    resetArea(); getArea($event.value)
                                "
                                formControlName="city_id"
                                placeholder="{{
                                    'prescription.city' | translate
                                }}"
                            >
                                <mat-option
                                    *ngFor="let city of cities"
                                    [value]="city.id"
                                >
                                    {{ city.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.city_id?.errors
                                        ?.required
                                "
                                translate
                            >
                                {{
                                    "prescription.cityRequired" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>

                    <div
                        *ngIf="
                            (!environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP &&
                                environmentVariables?.ENABLE_MULTI_INVENTORY) ||
                            !environmentVariables?.ENABLE_MULTI_INVENTORY ||
                            !environmentVariables?.SHOW_ADDRESS_MAP
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <mat-select
                                formControlName="area_id"
                                (selectionChange)="
                                    environmentVariables?.ENABLE_DISTRICT
                                        ? getDistrictV2($event)
                                        : null
                                "
                                placeholder="{{
                                    'prescription.area' | translate
                                }}"
                            >
                                <mat-option
                                    *ngFor="let city of areaList"
                                    [value]="city.id"
                                >
                                    {{ city.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.area_id?.errors
                                        ?.required
                                "
                                translate
                            >
                                {{
                                    "prescription.areaRequired" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="environmentVariables?.ENABLE_DISTRICT"
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <mat-select
                                formControlName="district_id"
                                placeholder="{{
                                    'prescription.district' | translate
                                }}"
                            >
                                <mat-option
                                    *ngFor="let city of districts"
                                    [value]="city.id"
                                >
                                    {{ city.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.district_id
                                        ?.errors?.required
                                "
                                translate
                            >
                                {{
                                    "prescription.districtRequired" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>

                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_APT_CONFIG != 'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <input
                                formControlName="apartment"
                                matInput
                                placeholder="{{
                                    environmentVariables?.ADDRESS_APT_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_APT_LABEL_EN
                                            : environmentVariables?.ADDRESS_APT_LABEL_AR
                                        : ('prescription.apartment' | translate)
                                }}"
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.apartment?.errors
                                        ?.required
                                "
                                [ngClass]="{ 'text-right': lang == 'ar' }"
                                >{{
                                    environmentVariables?.ADDRESS_APT_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_APT_LABEL_EN
                                            : environmentVariables?.ADDRESS_APT_LABEL_AR
                                        : ("prescription.apartment" | translate)
                                }}
                                {{ "prescription.Required" | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_BUILDING_CONFIG !=
                            'hide'
                        "
                        fxFlex="33.33"
                        fxFlex.xs="100"
                        fxFlex.sm="100"
                        class="px-1"
                    >
                        <mat-form-field class="w-100 mb-3">
                            <input
                                matInput
                                placeholder="{{
                                    environmentVariables?.ADDRESS_BUILDING_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_BUILDING_LABEL_EN
                                            : environmentVariables?.ADDRESS_BUILDING_LABEL_AR
                                        : ('input_text.InputBuilding'
                                          | translate)
                                }}"
                                formControlName="building"
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.building?.errors
                                        ?.required
                                "
                                [ngClass]="{ 'text-right': lang == 'ar' }"
                                >{{
                                    environmentVariables?.ADDRESS_BUILDING_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_BUILDING_LABEL_EN
                                            : environmentVariables?.ADDRESS_BUILDING_LABEL_AR
                                        : ("input_text.InputBuilding"
                                          | translate)
                                }}
                                {{ "prescription.Required" | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_FLOOR_CONFIG != 'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                        fxFlex.xs="50"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <input
                                formControlName="floor"
                                matInput
                                placeholder="{{
                                    'prescription.floor' | translate
                                }}"
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.floor?.errors
                                        ?.required
                                "
                                [ngClass]="{ 'text-right': lang == 'ar' }"
                                translate
                            >
                                {{
                                    "prescription.floorRequired" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_LANDMARK_CONFIG !=
                            'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <input
                                formControlName="landmark"
                                matInput
                                placeholder="{{
                                    environmentVariables?.ADDRESS_LANDMARK_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_LANDMARK_LABEL_EN
                                            : environmentVariables?.ADDRESS_LANDMARK_LABEL_AR
                                        : ('prescription.landmark' | translate)
                                }}"
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.landmark?.errors
                                        ?.required
                                "
                                [ngClass]="{ 'text-right': lang == 'ar' }"
                                translate
                            >
                                {{
                                    environmentVariables?.ADDRESS_LANDMARK_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_LANDMARK_LABEL_EN
                                            : environmentVariables?.ADDRESS_LANDMARK_LABEL_AR
                                        : ("prescription.landmark" | translate)
                                }}
                                {{ "prescription.Required" | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_SHOP_NAME_CONFIG !=
                            'hide'
                        "
                        class="px-1"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <mat-form-field
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            class="w-100"
                        >
                            <input
                                formControlName="shop_name"
                                matInput
                                placeholder="{{
                                    environmentVariables?.ADDRESS_SHOP_NAME_LABEL_EN
                                        ? lang == 'en'
                                            ? environmentVariables?.ADDRESS_SHOP_NAME_LABEL_EN
                                            : environmentVariables?.ADDRESS_SHOP_NAME_LABEL_AR
                                        : ('prescription.shop_name' | translate)
                                }}"
                            />
                            <mat-error
                                *ngIf="
                                    addAddressForm?.controls?.shop_name?.errors
                                        ?.required
                                "
                                [ngClass]="{ 'text-right': lang == 'ar' }"
                                translate
                            >
                                {{
                                    environmentVariables?.ADDRESS_SHOP_NAME_LABEL_EN
                                        ? lang == "en"
                                            ? environmentVariables?.ADDRESS_SHOP_NAME_LABEL_EN
                                            : environmentVariables?.ADDRESS_SHOP_NAME_LABEL_AR
                                        : ("prescription.shop_name" | translate)
                                }}
                                {{
                                    "prescription.Required" | translate
                                }}</mat-error
                            >
                        </mat-form-field>
                    </div>


                          <!-- commercial_record -->
            <div
            *ngIf="
                environmentVariables?.ADDRESS_COMMERCIAL_RECORD_CONFIG != 'hide'
            "
            class="px-1"
            fxFlex="100"
            fxFlex.gt-sm="33.3"
        >
            <mat-form-field
                [ngClass]="{ 'text-right': lang == 'ar' }"
                class="w-100"
            >
                <input
                    formControlName="commercial_record"
                    matInput
                    placeholder="{{
                        environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_EN
                            ? lang == 'en'
                                ? environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_EN
                                : environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_AR
                            : ('prescription.commercial_record' | translate)
                    }}"
                />
                <mat-error
                    *ngIf="
                        addAddressForm?.controls?.commercial_record?.errors
                            ?.required
                    "
                    [ngClass]="{ 'text-right': lang == 'ar' }"
                    translate
                >
                    {{
                        environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_EN
                            ? lang == "en"
                                ? environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_EN
                                : environmentVariables?.ADDRESS_COMMERCIAL_RECORD_LABEL_AR
                            : ("prescription.commercial_record" | translate)
                    }}
                    {{ "prescription.Required" | translate }}</mat-error
                >
            </mat-form-field>
        </div>
        <!-- bank_account -->
        <div
            *ngIf="
                environmentVariables?.ADDRESS_BANK_ACCOUNT_CONFIG != 'hide'
            "
            class="px-1"
            fxFlex="100"
            fxFlex.gt-sm="33.3"
        >
            <mat-form-field
                [ngClass]="{ 'text-right': lang == 'ar' }"
                class="w-100"
            >
                <input
                    formControlName="bank_account"
                    matInput
                    placeholder="{{
                        environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_EN
                            ? lang == 'en'
                                ? environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_EN
                                : environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_AR
                            : ('prescription.bank_account' | translate)
                    }}"
                />
                <mat-error
                    *ngIf="
                        addAddressForm?.controls?.bank_account?.errors
                            ?.required
                    "
                    [ngClass]="{ 'text-right': lang == 'ar' }"
                    translate
                >
                    {{
                        environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_EN
                            ? lang == "en"
                                ? environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_EN
                                : environmentVariables?.ADDRESS_BANK_ACCOUNT_LABEL_AR
                            : ("prescription.bank_account" | translate)
                    }}
                    {{ "prescription.Required" | translate }}</mat-error
                >
            </mat-form-field>
        </div>
        <!-- contact_number -->
        <div
            *ngIf="
                environmentVariables?.ADDRESS_CONTACT_NUMBER_CONFIG != 'hide'
            "
            class="px-1"
            fxFlex="100"
            fxFlex.gt-sm="33.3"
        >
            <mat-form-field
                [ngClass]="{ 'text-right': lang == 'ar' }"
                class="w-100"
            >
                <input
                    formControlName="contact_number"
                    matInput
                    placeholder="{{
                        environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_EN
                            ? lang == 'en'
                                ? environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_EN
                                : environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_AR
                            : ('prescription.contact_number' | translate)
                    }}"
                />
                <mat-error
                    *ngIf="
                        addAddressForm?.controls?.contact_number?.errors
                            ?.required
                    "
                    [ngClass]="{ 'text-right': lang == 'ar' }"
                    translate
                >
                    {{
                        environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_EN
                            ? lang == "en"
                                ? environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_EN
                                : environmentVariables?.ADDRESS_CONTACT_NUMBER_LABEL_AR
                            : ("prescription.contact_number" | translate)
                    }}
                    {{ "prescription.Required" | translate }}</mat-error
                >
            </mat-form-field>
        </div>





                    <div fxFlex="100" fxFlex.gt-sm="100"></div>

                    <!-- ADDRESS_SHOP_IMAGE_CONFIG -->
                    <div
                        *ngIf="
                            environmentVariables?.ADDRESS_SHOP_IMAGE_CONFIG !=
                            'hide'
                        "
                        class="image-uploader-inp"
                        fxFlex="100"
                        fxFlex.gt-sm="33.3"
                    >
                        <p class="image-label">
                            {{
                                environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_EN
                                    ? lang == "en"
                                        ? environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_EN
                                        : environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_AR
                                    : ("prescription.shop_image" | translate)
                            }}
                        </p>
                        <app-image-uploader
                            (uploadedImageUrl)="uploadedImageUrl($event, 'shop_image')"
                            [formControlChildName]="'shop_image'"
                            [myForm]="addAddressForm"
                            class="w-100"
                            [fileUrl]="addAddressForm.value.shop_image"
                            [fileType]="'image'"
                            height="240px"
                            width="100%"
                            [noPreview]="true"
                        >
                        </app-image-uploader>
                        <mat-error
                            *ngIf="
                                addAddressForm?.controls?.shop_image?.invalid &&
                                (addAddressForm?.controls?.shop_image?.touched ||
                                addAddressForm?.controls?.shop_image?.dirty) &&
                                addAddressForm?.controls?.shop_image?.errors
                                    ?.required && addressSubmitted
                            "
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            translate
                        >
                            {{
                                environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_EN
                                    ? lang == "en"
                                        ? environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_EN
                                        : environmentVariables?.ADDRESS_SHOP_IMAGE_LABEL_AR
                                    : ("prescription.shop_image" | translate)
                            }}
                            {{ "prescription.Required" | translate }}</mat-error
                        >
                    </div>
                        <!-- ADDRESS_ATTACHMENT_2_CONFIG -->
                      <div
                          *ngIf="
                              environmentVariables?.ADDRESS_ATTACHMENT_2_CONFIG !=
                              'hide'
                          "
                          class="image-uploader-inp mx-3"
                          fxFlex="100"
                          fxFlex.gt-sm="30"
                      >
                          <p class="image-label">
                              {{
                                  environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_EN
                                      ? lang == "en"
                                          ? environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_EN
                                          : environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_AR
                                      : ("prescription.shop_image" | translate)
                              }}
                          </p>
                          <app-image-uploader
                              (uploadedImageUrl)="uploadedImageUrl($event, 'attachment_2')"
                              [formControlChildName]="'attachment_2'"
                              [myForm]="addAddressForm"
                              class="w-100"
                              [fileUrl]="addAddressForm.value.attachment_2"
                              height="240px"
                              width="100%"
                              [fileType]="'image'"
                              [noPreview]="true"
                          >
                          </app-image-uploader>
                          <mat-error
                              *ngIf="
                                addAddressForm?.controls?.attachment_2?.invalid &&
                                (addAddressForm?.controls?.attachment_2?.touched ||
                                addAddressForm?.controls?.attachment_2?.dirty) &&
                                addAddressForm?.controls?.attachment_2?.errors
                                    ?.required && addressSubmitted
                              "
                              [ngClass]="{ 'text-right': lang == 'ar' }"
                              translate
                          >
                              {{
                                  environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_EN
                                      ? lang == "en"
                                          ? environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_EN
                                          : environmentVariables?.ADDRESS_ATTACHMENT_2_LABEL_AR
                                      : ("prescription.shop_image" | translate)
                              }}
                              {{ "prescription.Required" | translate }}</mat-error
                          >
                      </div>

                      <!-- ADDRESS_ATTACHMENT_3_CONFIG -->
                      <div
                          *ngIf="
                              environmentVariables?.ADDRESS_ATTACHMENT_3_CONFIG !=
                              'hide'
                          "
                          class="image-uploader-inp mx-3"
                          fxFlex="100"
                          fxFlex.gt-sm="30"
                      >
                          <p class="image-label">
                              {{
                                  environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_EN
                                      ? lang == "en"
                                          ? environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_EN
                                          : environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_AR
                                      : ("prescription.shop_image" | translate)
                              }}
                          </p>
                          <app-image-uploader
                              (uploadedImageUrl)="uploadedImageUrl($event, 'attachment_3')"
                              [formControlChildName]="'attachment_3'"
                              [myForm]="addAddressForm"
                              class="w-100"
                              [fileUrl]="addAddressForm.value.attachment_3"
                              height="240px"
                              width="100%"
                              [fileType]="'image'"
                              [noPreview]="true"
                          >
                          </app-image-uploader>
                          <mat-error
                              *ngIf="
                                addAddressForm?.controls?.attachment_3?.invalid &&
                                (addAddressForm?.controls?.attachment_3?.touched ||
                                addAddressForm?.controls?.attachment_3?.dirty) &&
                                addAddressForm?.controls?.attachment_3?.errors
                                      ?.required && addressSubmitted
                              "
                              [ngClass]="{ 'text-right': lang == 'ar' }"
                              translate
                          >
                              {{
                                  environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_EN
                                      ? lang == "en"
                                          ? environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_EN
                                          : environmentVariables?.ADDRESS_ATTACHMENT_3_LABEL_AR
                                      : ("prescription.shop_image" | translate)
                              }}
                              {{ "prescription.Required" | translate }}</mat-error
                          >
                      </div>


                    <div class="px-1" fxFlex="100">
                        <mat-checkbox color="primary" formControlName="primary">
                            {{
                                "prescription.setAsDefault" | translate
                            }}</mat-checkbox
                        >
                    </div>
                    <div
                        class="text-center mt-2 media-margin-button"
                        fxFlex="100"
                        style="margin-top: 45px"
                    >
                        <button
                            (click)="onEditAddressFormFormSubmit()"
                            *ngIf="address"
                            class="primary-button"
                            [disabled]="loadingSpinner"
                            mat-raised-button
                        >
                            {{ "prescription.edit" | translate }}
                            <app-loading *ngIf="loadingSpinner"></app-loading>
                        </button>
                        <button
                            (click)="onaddAddressFormFormSubmit()"
                            [disabled]="loadingSpinner"
                            *ngIf="!address"
                            class="primary-button"
                            mat-raised-button
                        >
                            {{ "prescription.save" | translate }}
                            <app-loading *ngIf="loadingSpinner"></app-loading>
                        </button>
                    </div>
                </ng-container>
            </div>
        </form>
    </div>
</div>
